import React from 'react'

const Advanced_EXCEL = () => {
  return (
    <div>
        {/* collapseFiftyEight */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftyEight">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyEight" aria-expanded="false" aria-controls="collapseFiftyEight">
                    Advanced EXCEL <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftyEight" className="accordion-collapse collapse" aria-labelledby="headingFiftyEight" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Advanced Functions and Formulas</strong>
                    <ul>
                        <li>Review of basic functions (SUM, IF, VLOOKUP, etc.)</li>
                        <li>Advanced lookup functions (INDEX/MATCH, XLOOKUP)</li>
                        <li>Logical functions (AND, OR, IFERROR, etc.)</li>
                        <li>Text functions (CONCATENATE, LEFT, RIGHT, MID, etc.)</li>
                        <li>Date and time functions (DATE, EDATE, WEEKDAY, etc.)</li>
                    </ul>

                    <strong>Array Formulas and Dynamic Arrays</strong>
                    <ul>
                        <li>Understanding array formulas</li>
                        <li>Array functions (TRANSPOSE, FREQUENCY, MMULT, etc.)</li>
                        <li>Introduction to dynamic arrays (FILTER, SORT, UNIQUE, etc.)</li>
                        <li>Using dynamic arrays for data analysis and manipulation</li>
                    </ul>

                    <strong>Data Analysis Tools</strong>
                    <ul>
                        <li>Introduction to Excel Tables</li>
                        <li>PivotTables: basics and advanced techniques</li>
                        <li>PivotCharts and Slicers for interactive analysis</li>
                        <li>Using Power Query for data cleaning and transformation</li>
                        <li>Introduction to Power Pivot for advanced data modeling</li>
                    </ul>

                    <strong>Data Analysis Tools</strong>
                    <ul>
                        <li>Statistical analysis with Excel (Descriptive statistics, Regression, etc.)</li>
                        <li>Advanced charting techniques (Sparklines, Combo charts, etc.)</li>
                        <li>Incorporating custom calculations into PivotTables</li>
                    </ul>

                    <strong>Macros and VBA Programming</strong>
                    <ul>
                        <li>Recording and editing macros</li>
                        <li>Introduction to Visual Basic for Applications (VBA)</li>
                        <li>Writing custom macros using VBA</li>
                        <li>Automation techniques and best practices</li>
                    </ul>

                    <strong>Data Visualization and Dashboarding</strong>
                    <ul>
                        <li>Design principles for effective dashboards</li>
                        <li>Creating dynamic charts and graphs</li>
                        <li>Using conditional formatting for visual insights</li>
                        <li>Building interactive dashboards with form controls</li>
                    </ul>

                    <strong>Collaboration and Integration</strong>
                    <ul>
                        <li>Importing and exporting data between Excel and other applications (Word, PowerPoint, etc.)</li>
                        <li>Introduction to Power BI for advanced data visualization and analysis</li>
                        <li>Integrating Excel with other Microsoft Office apps</li>
                    </ul>

                    <strong>Advanced Data Techniques</strong>
                    <ul>
                        <li>Using array formulas for advanced calculations</li>
                        <li>Techniques for handling large datasets</li>
                        <li>Advanced filtering and sorting techniques</li>
                        <li>Tips for efficient data management and organization</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Advanced_EXCEL